import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service'
import { RuntimeService } from '../runtime.service'

@Component({
  selector: 'app-project-dashboard',
  templateUrl: './project-dashboard.component.html',
  styleUrls: ['./project-dashboard.component.css']
})
export class ProjectDashboardComponent implements OnInit {

  constructor(
    public projects: ProjectService,
    private rts: RuntimeService
  ) {
    this.rts.adminType = 'projects'
    this.rts.resetCurrentProject();
   }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/project-dashboard/project-dashboard.component.ts